// extracted by mini-css-extract-plugin
export default {"appContainer":"app_appContainer__P7YEM","navContainer":"app_navContainer__81RhN","mainContainer":"app_mainContainer__pmkSZ"};